import { API_BASE_URL } from "./config";

export const login = async (
  code: string,
  password: string,
): Promise<{ success: boolean; role?: any; message?: string }> => {
  const response = await fetch(`${API_BASE_URL}/login`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ code, password }),
  });

  if (!response.ok) {
    throw new Error("Ошибка авторизации");
  }

  return response.json();
};

export const generatePassword = async (
  code: string,
  password: string,
  participantName: string,
): Promise<{
  success: boolean;
  generatedPassword?: string;
  message?: string;
}> => {
  const response = await fetch(`${API_BASE_URL}/generate-password`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ code, password, participantName }),
  });

  if (!response.ok) {
    throw new Error("Ошибка генерации пароля");
  }

  return response.json();
};
